import styled, { css } from "styled-components"

import { minWidth, when, eq } from "utils"

import ContentfulTextWithMedia from "components/page-components/text-with-media"

export const Container = styled(ContentfulTextWithMedia)`
  width: 100%;
  display: flex;
  background-color: #f6f6f6;

  ${when("isAdvertisement")`
    background-color: #fff !important;
  `}

  ${when("hasSignupForm")`
    background-color: #fff !important;
  `}

  // horizontal
  > :first-child {
    flex-direction: column;

    ${minWidth.desktop`
      ${when("sideBySide")`
        flex-direction: row;
      `}
    `}

    // container
    > div {
      max-width: 100%;
      flex: 1;

      ${minWidth.desktop`
        ${when("below")`
          max-width: 60%;
          flex: 0 0 60%;
        `}
      `}

      // left: hero
      &:nth-child(1) {
        padding: 2rem 1.6rem;

        ${when("isAdvertisement")`
          position: relative;
          padding-top: 0;
        `}

        ${minWidth.tablet`
          padding: 2.5rem 4rem;
        `}

        ${minWidth.hamburgerLarge`
          ${when("sideBySide")`
            padding: 3rem 4rem 2rem;

            ${when("isAdvertisement")`
              padding: 2.5rem;
            `}

            ${({ hasImage, hasVideo }) =>
              !(hasImage || hasVideo) &&
              css`
                max-width: 100%;
                flex: 0 0 100%;
              `}
          `}
        `}

        // preheading
        h3 {
          margin-bottom: 1rem;
          padding-top: 0;
          font-size: 1.6rem;
          font-weight: 500;
          line-height: 1.625;
          color: ${({ theme }) => theme.colors.text.primary};

          ${minWidth.desktop`
            font-size: 1.8rem;
            line-height: 1.667;
          `}

          ${when("isAdvertisement")`
            width: 60%;
            padding-top: 6rem;

            ${minWidth.tablet`
              padding-top: 4rem;
            `}

            ${minWidth.desktop`
              padding-top: 0;
            `}
          `}
        }

        // heading
        h1 {
          width: 100%;
          padding-top: 0;
          padding-bottom: 0.6rem;
          font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
          font-size: 2.8rem;
          line-height: 1.35;

          ${minWidth.desktop`
            width: ${({ hasPreheading, isAdvertisement }) =>
              isAdvertisement && !hasPreheading ? "60%" : "100%"};
            font-size: 2.8rem;
            line-height: 1.35;

            ${when("hasSignupForm")`
              font-size: 3.2rem;
            `}
          `}

          ${eq("hasSignupForm")`
            padding-top: 0 !important;
          `}

          ${when("isAdvertisement")`
            ${eq("hasPreheading", false)`
              padding-top: 6rem;

              ${minWidth.tablet`
                padding-top: 4rem;
              `}

              ${minWidth.desktop`
                padding-top: 0;
              `}
            `}

            ::after {
              content: "ADVERTISEMENT";
              position: absolute;
              top: 2.7rem;
              left: 1.6rem;
              font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
              font-size: 1.4rem;
              font-weight: 400;
              line-height: 1.93;
              letter-spacing: 0.1rem;
              color: #767676;

              ${minWidth.tablet`
                left: 4rem;
              `}

              ${minWidth.desktop`
                left: unset;
                right: 4rem;
              `}
            }
          `}
        }

        // subheading
        h4 {
          font-weight: 500;
          margin-top: 0.5rem;
        }

        // body text
        div > p,
        li {
          margin-top: 0;
          padding-top: 0.5rem;
          font-size: 1.6rem;
          line-height: 1.35;

          ${minWidth.desktop`
            font-size: 1.8rem;
            line-height: 1.667;

            ${when("hasSignupForm")`
              font-size: 1.6rem;
              line-height: 1.56;
            `}
          `}
        }

        input[type="email"] {
          margin-top: 0;
          margin-bottom: 0;

          ${when("hasSignupForm")`
            width: 100%;
            margin-bottom: 1.6rem;
            border: 0.1rem solid rgba(34, 34, 34, 0.20);
          `}
        }

        input[type="submit"],
        button {
          width: 100%;
          padding: 1.6rem 3rem;
          border: 0.1rem solid #222;
          font-size: 1.6rem;

          ${when("isAdvertisement")`
            background-color: #fff;
            color: #222;
          `}

          ${when("hasSignupForm")`
            position: static;
            height: 100%;
            margin: 0 0 1.6rem 0;
            border: 0;
            background-color: ${({ theme }) => theme.colors.primaryOrange};
          `}
        }
      }

      // right: media
      &:nth-child(2) {
        order: -1;

        ${when("hasVideo")`
          section > div:first-child {
            width: 100%;
          }
        `}

        ${minWidth.desktop`
          ${({ sideBySide }) =>
            sideBySide
              ? css`
                  max-width: 40%;
                  flex: 0 0 40%;
                  order: ${({ mediaPosition }) => (mediaPosition === "Left" ? -1 : 1)};

                  ${({ hasImage, hasVideo }) =>
                    !(hasImage || hasVideo) &&
                    css`
                      max-width: 0;
                      flex: 0 0 0;
                    `}
                `
              : css`
                  div > div {
                    ${when("hasImage")`
                      position: relative;
                      height: 0;
                      padding-top: 56.25%;
                    `}
                  }
                `}
        `}
      }
    }
  }

  ${minWidth.tablet`
    max-width: 58rem;
  `}

  ${minWidth.desktop`
    max-width: 72.5rem;

    ${when("below")`
      max-width: 100%;
    `}
  `}

  form {
    ${when("hasSignupForm")`
      text-align: left !important;

      .signup-success {
        height: unset;
        margin: 0;
      }

      // terms
      > :last-child {
        color: rgba(34, 34, 34, 0.60);

        ${minWidth.mobile`
          margin-top: 1.2rem;
        `}
      }
    `}

    input {
      width: 100%;
    }
  }
`
